import React, { Component } from 'react';
import { InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';

class QuickReplyButtons extends Component {
	constructor(props) {
		super(props);
		this.state = {
			atualButton: '',
		};
	}

	addCustomizedButton = () => {
		if (this.state.atualButton.trim()) {
			this.props.onAddButton({ label: this.state.atualButton.trim(), selected: false });
			this.setState({
				atualButton: '',
			});
		}
	};

	renderButton = (button) => (
		<button
			key={button.label}
			style={{
				boxSizing: 'border-box',
				color: button.selected ? '#35c3ef' : 'rgb(173, 173, 173)',
				minWidth: '80px',
				maxWidth: 'auto',
				padding: '10px',
				border: button.selected ? '1.5px solid #35c3ef' : '1.5px solid rgb(138, 138, 138)',
				outline: button.selected ? '2px solid #35c3ef' : 'none',
				borderRadius: '5px',
				fontSize: '14px',
				fontWeight: 'bold',
				backgroundColor: button.selected ? 'rgb(252, 248, 248)' : 'rgb(233, 233, 233)',
				cursor: 'pointer',
				transition: 'background-color 0.3s ease',
			}}
			onClick={() => this.props.onSelectButton(button.label)}
			onMouseEnter={(e) => (e.target.style.opacity = '0.9')}
			onMouseLeave={(e) => (e.target.style.opacity = '1')}
		>
			{button.label}
		</button>
	);

	render() {
		const { language, totalButtons } = this.props;

		return (
			<div>
				<div
					style={{
						maxWidth: '100%',
						margin: '20px auto',
						padding: '15px',
						borderRadius: '10px',
						backgroundColor: '#fafafa',
						border: '1px dashed #d9d9d9',
						boxShadow: '0 2px 5px rgba(165, 165, 165, 0.1)',
					}}
				>
					<div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'row' }}>
						<p style={{ fontSize: '14px', color: '#333', marginBottom: '15px' }}>
							{language.rapid_reply_title}
						</p>
						<Tooltip title={<FormattedMessage id="rapid_reply_tooltip" />}>
							<InfoCircleOutlined
								style={{ color: '#08AAF2', fontSize: '16px', marginBottom: '15px' }}
							/>
						</Tooltip>
					</div>

					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							gap: '10px',
							flexWrap: 'wrap',
							justifyContent: 'start',
						}}
					>
						{totalButtons.map(this.renderButton)}
					</div>

					<div style={{ display: 'flex', marginTop: '15px', gap: '10px', alignItems: 'center' }}>
						<input
							type="text"
							value={this.state.atualButton}
							onChange={(e) => this.setState({ atualButton: e.target.value })}
							placeholder={language.new_button_placeholder}
							style={{
								flex: '1',
								padding: '8px',
								borderRadius: '5px',
								border: '1px solid #ccc',
								fontSize: '14px',
							}}
						/>
						<button
							onClick={this.addCustomizedButton}
							style={{
								padding: '8px 15px',
								border: 'none',
								borderRadius: '5px',
								fontSize: '14px',
								backgroundColor: '#35c3ef',
								color: 'white',
								cursor: 'pointer',
								transition: 'background-color 0.3s ease',
							}}
						>
							<PlusOutlined style={{ fontWeight: 'bold', fontSize: '18px' }} />
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default QuickReplyButtons;
